/**
 * EXEMPLO DE USO DA FUNÇÃO enumRecordToCheckboxOptions
 *
 * Este arquivo demonstra como criar opções de checkbox a partir de enums
 * de forma reutilizável e type-safe em todo o projeto.
 */

import { enumRecordToCheckboxOptions } from '../helpers';

// ============================================================================
// EXEMPLO 1: Enum de Status
// ============================================================================

export enum Status {
  Active = 0,
  Inactive = 1,
  Pending = 2,
  Suspended = 3,
}

export const STATUS_RECORD: Record<Status, string> = {
  [Status.Active]: 'Ativo',
  [Status.Inactive]: 'Inativo',
  [Status.Pending]: 'Pendente',
  [Status.Suspended]: 'Suspenso',
};

export const STATUS_OPTIONS = enumRecordToCheckboxOptions(STATUS_RECORD);

// ============================================================================
// EXEMPLO 2: Enum de Prioridades
// ============================================================================

export enum Priority {
  Low = 0,
  Medium = 1,
  High = 2,
  Critical = 3,
}

export const PRIORITY_RECORD: Record<Priority, string> = {
  [Priority.Low]: 'Baixa',
  [Priority.Medium]: 'Média',
  [Priority.High]: 'Alta',
  [Priority.Critical]: 'Crítica',
};

export const PRIORITY_OPTIONS = enumRecordToCheckboxOptions(PRIORITY_RECORD);

// ============================================================================
// EXEMPLO 3: Enum de Dias da Semana
// ============================================================================

export enum Weekday {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export const WEEKDAY_RECORD: Record<Weekday, string> = {
  [Weekday.Sunday]: 'Domingo',
  [Weekday.Monday]: 'Segunda-feira',
  [Weekday.Tuesday]: 'Terça-feira',
  [Weekday.Wednesday]: 'Quarta-feira',
  [Weekday.Thursday]: 'Quinta-feira',
  [Weekday.Friday]: 'Sexta-feira',
  [Weekday.Saturday]: 'Sábado',
};

export const WEEKDAY_OPTIONS = enumRecordToCheckboxOptions(WEEKDAY_RECORD);

// ============================================================================
// USO EM COMPONENTES
// ============================================================================

/**
 * Em um componente Angular:
 *
 * import { STATUS_OPTIONS, PRIORITY_OPTIONS, WEEKDAY_OPTIONS } from '@umss/shared/utils';
 *
 * @Component({
 *   selector: 'app-filters',
 *   template: `
 *     <umss-checkbox-group
 *       label="Status"
 *       [options]="statusOptions"
 *       [(selectedValues)]="selectedStatuses"
 *     />
 *
 *     <umss-checkbox-group
 *       label="Prioridade"
 *       [options]="priorityOptions"
 *       [(selectedValues)]="selectedPriorities"
 *     />
 *
 *     <umss-checkbox-group
 *       label="Dias da Semana"
 *       [options]="weekdayOptions"
 *       [(selectedValues)]="selectedWeekdays"
 *     />
 *   `
 * })
 * export class FiltersComponent {
 *   statusOptions = STATUS_OPTIONS;
 *   priorityOptions = PRIORITY_OPTIONS;
 *   weekdayOptions = WEEKDAY_OPTIONS;
 *
 *   selectedStatuses: Status[] = [];
 *   selectedPriorities: Priority[] = [];
 *   selectedWeekdays: Weekday[] = [];
 * }
 */
